import { IdleValue } from 'idlize/IdleValue.mjs';
import { cdn } from '../../app/support/helpers';
import { keys, isDesktopSize } from './functions';
import Practitioner from '../../app/models/Practitioner';

new IdleValue(() => {
    // Run expensive code and return the result...

    const practitioner = Practitioner.new(window.doctori.practitioner as {});

    var gMapsLoaded = false;

    var params = $.param({
        'key': keys('google_api'),
        'callback': 'doctorMapCallback'
    });

    var googleMapsApiUrl = `https://maps.googleapis.com/maps/api/js?${params}`;
    // console.log('googleMapsApiUrl: ', googleMapsApiUrl);

    // @ts-ignore
    window.doctorMapCallback = function () {
        // console.log('doctorMapCallback() fired');
        gMapsLoaded = true;
        // trigger "gMapsLoaded" event
        $(window).trigger('gMapsLoaded');
    }

    function loadGoogleMaps() {
        // console.log('loadGoogleMaps() function fired');
        // console.log('gMapsLoaded: ', gMapsLoaded);
        if (gMapsLoaded) {
            // @ts-ignore
            return window.doctorMapCallback();
        }
        // console.log('Create script tag');
        var scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'text/javascript');
        scriptTag.setAttribute('src', googleMapsApiUrl);
        (document.getElementsByTagName('head')[0] || document.documentElement).appendChild(scriptTag);
        document.getElementById('map').classList.add("map-rendered")
    }


    function initialize() {
        // console.log('initialize() fired ');
        var infowindow;

        var doctorMarker = {

            "latitude": practitioner.lat(),
            "longitude": practitioner.lng(),
            "icon": cdn('images/marker.svg'),
            "baloon_text": '<div>' + practitioner.fullAddress() + '</div>'

        };

        var myOptions = {

            zoom: 14,
            scrollwheel: false,
            fullscreenControl: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        var mapObj = new google.maps.Map(document.getElementById('map'), myOptions);
        // @ts-ignore
        var LatLng = new google.maps.LatLng(
            parseFloat(practitioner.lat() as any),
            parseFloat(practitioner.lng() as any)
        );

        mapObj.setCenter(LatLng);

        var marker = new google.maps.Marker({

            map: mapObj,
            position: new google.maps.LatLng(doctorMarker.latitude, doctorMarker.longitude),
            animation: google.maps.Animation.DROP,
            icon: doctorMarker.icon
        });

        marker.addListener('click', function () {

            if (infowindow) {
                infowindow.close();
            }

            infowindow = new google.maps.InfoWindow({
                content: doctorMarker.baloon_text
            });

            infowindow.open(mapObj, marker);
        });

        $(document).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function () {

            // @ts-ignore
            var isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

            google.maps.event.trigger(mapObj, 'resize');
            mapObj.setCenter(LatLng);
        });
    }

    // when "gMapsLoaded" event is fired, execute "initialize" function
    $(window).bind('gMapsLoaded', initialize);

    // in all cases add an event listener to show the map
    // in case the user is already in mobile mode, or
    // in case the user resized his browser to tablet and down
    $('#carte .showMap').on('click', function () {
        // console.log('#carte .showMap clicked');
        loadGoogleMaps();
    });

    $('#map').on('click', function () {
        if (gMapsLoaded) return;
        loadGoogleMaps();
    });

    // if it's desktop load google maps immediately
    // if (isDesktopSize()) {
    //     loadGoogleMaps();
    // }
});
